import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';

@Injectable()
export class PasswordResetForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      email: [ '', Validators.compose([ Validators.required, CustomValidators.email ]) ]
    });
  }
}
